import React from 'react';

interface RowDividerProps {
  children?: React.ReactNode;
  className?: string;
  colorClassName?: string;
}

export const RowDivider = ({
  children,
  className = '',
  colorClassName = 'bg-gray-200',
}: RowDividerProps) => {
  // If no children, just render a simple divider line
  if (!children) {
    return <div className={`w-full h-px ${colorClassName} ${className}`} />;
  }

  // With children, render a divider with content in the middle
  return (
    <div className={`w-full flex items-center ${className}`}>
      <div className={`grow h-px ${colorClassName}`} />
      <div className="px-4">{children}</div>
      <div className={`grow h-px ${colorClassName}`} />
    </div>
  );
};
